import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

/**
 * Completion page for Entity Formation Intake submission
 * Reads submissionId from query string and shows confirmation
 * Authentication is handled by ProtectedRoute in App.tsx
 */
const EntityFormationIntakeCompletePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const submissionId = searchParams.get('submissionId');

  const handleReturnToDashboard = () => {
    navigate('/client-dashboard');
  };

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '64px', marginBottom: '20px' }}>✓</div>
        <h1 style={{ marginBottom: '20px', color: '#28a745' }}>
          Submission received
        </h1>
        
        {submissionId ? (
          <>
            <p style={{ fontSize: '18px', marginBottom: '30px', color: '#666' }}>
              Thank you for submitting your entity formation intake form.
            </p>
            <div style={{ 
              backgroundColor: '#f5f5f5', 
              padding: '20px', 
              borderRadius: '8px',
              marginBottom: '40px',
              textAlign: 'left',
              display: 'inline-block'
            }}>
              <div style={{ marginBottom: '10px' }}>
                <strong>Submission ID:</strong> {submissionId}
              </div>
              <div style={{ fontSize: '14px', color: '#666' }}>
                Please save this ID for your records.
              </div>
            </div>
          </>
        ) : (
          <p style={{ fontSize: '18px', marginBottom: '40px', color: '#666' }}>
            Your submission has been received. Our team will review it and contact you soon.
          </p>
        )}

        <div>
          <button
            onClick={handleReturnToDashboard}
            style={{
              padding: '12px 24px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '16px',
              cursor: 'pointer',
              fontWeight: '500',
            }}
          >
            Return to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default EntityFormationIntakeCompletePage;

